import { render, staticRenderFns } from "./kouyulist.vue?vue&type=template&id=0b13b392&scoped=true&"
import script from "./kouyulist.vue?vue&type=script&lang=js&"
export * from "./kouyulist.vue?vue&type=script&lang=js&"
import style0 from "./kouyulist.vue?vue&type=style&index=0&id=0b13b392&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13b392",
  null
  
)

export default component.exports